import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthenticationComponent} from './authentication.component';
import { LogoutComponent } from './logout.component';
import { ResetPwdComponent, ForgotPwdComponent, ForgotPwdLinkComponent, SecurityQuestionsComponent } from './index'
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { EmailConfirmationComponent } from './email-confirmation/email-confirmation';
import { CommonModule } from '@angular/common';
import { AccountConfirmationComponent } from './account-confirmation/account-confirmation';
import { ForgotUsernameComponent } from './forgot-username/forgot-username.component';
import { CookieService } from 'ngx-cookie-service';
import { PopoverModule as NgxPopOver } from 'ngx-bootstrap/popover';
import { SharedModule } from '../shared';
import { AbleBaseLoginComponent } from './base-login.component';

@NgModule({
  imports: [
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    NgxPopOver.forRoot()
  ],
  declarations: [
    AuthenticationComponent,
    ForgotPwdComponent,
    ForgotUsernameComponent,
    ForgotPwdLinkComponent,
    LogoutComponent,
    ResetPwdComponent,
    EmailConfirmationComponent,
    AccountConfirmationComponent,
    SecurityQuestionsComponent,
    AbleBaseLoginComponent
  ],
  exports: [
    RouterModule,
    AuthenticationComponent,
    ForgotPwdComponent,
    ForgotUsernameComponent,
    ForgotPwdLinkComponent,
    LogoutComponent,
    ResetPwdComponent,
    EmailConfirmationComponent,
    SecurityQuestionsComponent,
    AbleBaseLoginComponent
  ],
  providers: [
    CookieService
  ]
})

export class LoginModule { }
